import { forwardRef } from "react";
import { Search } from "lucide-react";

/**
 * Shared search input. Icon is absolutely positioned, left padding is reserved
 * on the input so placeholder and typed text never overlap the icon.
 *
 * Props:
 *   - size: "md" (default) | "lg"
 *   - className: optional extra classes on the wrapper
 *   - testId: data-testid for the <input>
 *   - all other props are forwarded to the <input>
 */
const SearchBar = forwardRef(function SearchBar(
  { size = "md", className = "", testId, placeholder = "Cerca...", ...rest },
  ref
) {
  const inputSize =
    size === "lg" ? "py-3 text-base" : "py-2.5 text-sm";
  return (
    <div className={`relative ${className}`}>
      <Search
        size={size === "lg" ? 20 : 18}
        className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[#6B7280]"
      />
      <input
        ref={ref}
        type="search"
        placeholder={placeholder}
        className={`maven-input with-left-icon pr-4 ${inputSize}`}
        data-testid={testId}
        {...rest}
      />
    </div>
  );
});

export default SearchBar;
